import { render, staticRenderFns } from "./RegisterSection.vue?vue&type=template&id=192c27bb&scoped=true&"
import script from "./RegisterSection.vue?vue&type=script&lang=js&"
export * from "./RegisterSection.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSection.vue?vue&type=style&index=0&id=192c27bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c27bb",
  null
  
)

export default component.exports